import { includes } from 'ramda';
import { newConversation, splitId } from '@twnel/utils-js/web';
import { CONVERSATIONS } from '../namespace';
import { updateConversation, registerActive } from '../reducer/conversations';
import { getUserId, getConversation, getActiveConversationIds } from '../selectors';
import { ENDPOINTS } from '../util';

export { updateConversation };

export const registerActiveConversation = (conversationId) => (dispatch, getState) => {
  const activeIds = getActiveConversationIds(getState());
  let conversation = getConversation(conversationId, getState());
  if (includes(conversationId, activeIds) && conversation) {
    return;
  }

  if (!conversation) {
    const userId = getUserId(getState());
    conversation = newConversation({
      with: `${conversationId}@${ENDPOINTS.XMPP_HOST}`,
      owner: `${userId}@${ENDPOINTS.XMPP_HOST}`,
    });
  }
  dispatch(registerActive(conversation));
};

const updateTyping = ({ conversationId, agentId = true }) => (typing) => (dispatch, getState) => {
  const conversation = getConversation(conversationId, getState());
  if (!conversation) {
    return conversation;
  }
  const updated = { ...conversation, typing: typing ? agentId : null };
  dispatch(updateConversation(updated));
  return updated;
};

export const onTypingEvent = (rawId) => (dispatch, getState, getContext) => {
  const { cacheStore } = getContext();
  const timeouts = cacheStore.get(`${CONVERSATIONS}/timeouts`);

  const { id: conversationId, agent } = splitId(rawId);

  const updateConversationTyping = updateTyping(conversationId, agent);
  if (dispatch(updateConversationTyping(true))) {
    const pendingTimeout = timeouts.get(conversationId);
    if (pendingTimeout) {
      clearTimeout(pendingTimeout);
    }

    const timeout = setTimeout(() => {
      timeouts.delete(conversationId);
      dispatch(updateConversationTyping(false));
    }, 3000);
    timeouts.set(conversationId, timeout);
  }
};
